var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showHeader)?_c('h1',{staticClass:"mb-3"},[_vm._v("Allgemeine Geschäftsbedingungen")]):_vm._e(),_c('static-content',{attrs:{"which":"terms-and-conditions"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }